// extracted by mini-css-extract-plugin
module.exports = {"container":"ReminderCategoriesTab_container__1ak0G"};